var parseSetMethodArgs = require('../utils/model.utils').parseSetMethodArgs;
var BBModel = Backbone.Model;
var BBModelSet = BBModel.prototype.set;

var setNestedValue = function(nestedProp, value, options) {
    var attrs = _.isFunction(_.get(value, 'toJSON')) ? value.toJSON() : value;
    var collectedEvents;
    nestedProp.__collectedEvents = {};
    nestedProp.set(attrs, options);
    collectedEvents = _.clone(nestedProp.__collectedEvents);
    delete nestedProp.__collectedEvents;
    return collectedEvents;
};

var triggerEventsPerProp = function(collectedEvents, options) {
    _.each(collectedEvents, _.bind(function(events, prop) {
        events.change = true;
        _.each(events, _.bind(function(exists, event) {
            this.trigger(event + ':' + prop, this, this.get(prop), options);
        }, this));
    }, this));
};

var triggerModelEvents = function(collectedEvents, options) {
    var events = _.merge.apply(null, _.toArray(collectedEvents));
    events.change = true;
    _.each(events, _.bind(function(exists, event) {
        this.trigger(event, this, options);
    }, this));
};

var NestedModel = BBModel.extend({
    toJSON: function() {
        var json = BBModel.prototype.toJSON.call(this);
        _.each(this.nestedProps, function(Class, prop) {
            json[prop] = json[prop].toJSON();
        });
        return json;
    },
    set: function() {
        var args = parseSetMethodArgs(arguments);
        var nestedProps = _.keys(this.nestedProps);
        var simpleAttrs = _.omit(args[0], nestedProps);
        var nestedAttrs = _.pick(args[0], nestedProps);
        var options = args[1];
        var nestedPropsEvents = {};
        var silentOptions = _.extend({}, options, {silent: true});
        if (_.isEmpty(this.attributes)) {
            initNestedProps.call(this, silentOptions);
        }
        BBModelSet.call(this, simpleAttrs, silentOptions);
        var simplePropsEvents = _.reduce(this.changedAttributes(), function(events, value, prop) {
            events[prop] = {
                change: true,
            };
            return events;
        }, {});
        _.each(nestedAttrs, _.bind(function(value, prop) {
            var nestedProp = this.get(prop);
            var events;
            if (_.has(nestedProp, 'models') || _.has(nestedProp, 'attributes')) {
                events = setNestedValue(nestedProp, value, options);
            }
            if (!_.isEmpty(events)) {
                nestedPropsEvents[prop] = events;
            }
        }, this));
        var collectedEvents = _.extend(nestedPropsEvents, simplePropsEvents);
        if (!_.isEmpty(collectedEvents)) {
            triggerEventsPerProp.call(this, collectedEvents, options);
            triggerModelEvents.call(this, collectedEvents, options);
        }
    },
});

var toRawObject = function(obj) {
    return _.isFunction(_.get(obj, 'toJSON')) ? obj.toJSON() : obj;
};

var initNestedProps = function(options) {
    var defaults = _.result(this, 'defaults', {});
    _.each(this.nestedProps, _.bind(function(Class, prop) {
        BBModelSet.call(this, prop, new Class(toRawObject(defaults[prop]), options), options);
    }, this));
};

var collectEvent = function(eventName) {
    if (!_.includes(eventName, ':')) {
        this.__collectedEvents[eventName] = true;
    }
};

NestedModel.extend = function(properties, classProperties) {
    return BBModel.extend.call(NestedModel, _.extend({}, properties, {
        initialize: function(attrs, options) {
            var initialize = properties.initialize || properties.constructor || _.noop;
            this.nestedProps = properties.nestedProps || {};
            _.each(this.nestedProps, _.bind(function(Class, prop) {
                var nestedProp = this.get(prop);
                nestedProp.on('all', collectEvent);
            }, this));
            initialize.call(this, attrs, options);
        },
    }), classProperties);
};

module.exports = NestedModel;
